import React,{useState} from "react";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import "survey-core/defaultV2.min.css"; // Survey.js v2 CSS dosyası

const SurveyPreview = ({ surveyData }) => {
  if (!surveyData) return <p>Loading survey preview...</p>;
  let surveyCopy=JSON.parse(JSON.stringify(surveyData))
  const arrangeSurvey = (surveyCopy) => {
    const _currentSurvey = JSON.parse(JSON.stringify(surveyCopy));
       if (_currentSurvey.asIsToBe) {
         _currentSurvey.pages.filter(x => x.name !== "intro" && x.type !== "demographics").forEach((page) => {
           page.elements[0].elements.forEach((element) => {
             if (element.type === "panel") {
               element.elements.forEach((subElement) => {
                 if (subElement.type === "radiogroup" || subElement.type === "dropdown" || subElement.type === "rating") {
                  const tempType = subElement.type
                  subElement.type = "matrixdropdown";
                  subElement.titleLocation = "hidden";
                  subElement.columns = []
                  if (tempType !== "rating"){
                    subElement.columns = [
                     {
                       name: subElement.name,
                       title: subElement.title,
                       cellType: tempType,
                       choices: subElement.choices
                     },
                    ]
                  }else{
                     subElement.columns = [
                      {
                        name: subElement.name,
                        title: subElement.title,
                        cellType: tempType,
                        rateCount: subElement.rateCount,
                        rateType: subElement.rateType,
                        rateMax : subElement.rateMax,
                        displayMode : subElement.buttons
                      },
                    ]
                  }
                  subElement.rows = [
                    { text: "Current", value: "Current" },
                    { text: "Target", value: "Target" }
                  ]
                  subElement.transposeData = true;
                 }
               });
             }else if (element.type === "paneldynamic") {
                const valueObj = {};
                element.templateElements.forEach((te) => {
                    
                    valueObj[te.name] = ""; // boş başlangıç değeri
                });

                element.value = [valueObj];
                element.panelCount = 1  
                element.readOnly= false
                element.allowAddPanel= false
                element.allowRemovePanel=false
                
               element.templateElements.forEach((subElement) => {
                  delete subElement.editing_type;
                  delete subElement.elements;
                  delete subElement.editing_elements;
                  delete subElement.editing_name;
                  delete subElement.editing_type;
                  delete subElement.editing_asIsToBe
                  delete subElement.editing_weight;
                  delete subElement.weight;
                  delete subElement.is_exist;    
                  delete subElement.isEditing;
                  subElement.visible = true
                  subElement.title =subElement.title
                  if (subElement.type === "radiogroup" || subElement.type === "dropdown" || subElement.type === "rating"){
                    const tempType = subElement.type
                    subElement.type = "matrixdropdown";
                    subElement.titleLocation = "hidden";
                    subElement.columns = []
                    if (tempType !== "rating"){
                      subElement.columns = [
                        {
                          name: subElement.name,
                          title: subElement.title,
                          cellType: tempType,
                          choices: subElement.choices
                        },
                      ]
                    }else{
                       subElement.columns = [
                        {
                          name: subElement.name,
                          title: subElement.title,
                          cellType: tempType,
                          rateCount: subElement.rateCount,
                          rateType: subElement.rateType,
                          rateMax : subElement.rateMax,
                          displayMode : subElement.buttons
                        },
                      ]
                    }
                   
                    subElement.rows = [
                      { text: "Current", value: "Current" },
                      { text: "Target", value: "Target" }
                    ]
                    subElement.transposeData = true;
                  }else if(subElement.type==="paneldynamic"){
                      const valueObj = {};
                      subElement.templateElements.forEach((te) => {
                          valueObj[te.name] = ""; // boş başlangıç değeri
                          delete te.editing_type;
                          delete te.elements;
                          delete te.editing_elements;
                          delete te.editing_name;
                          delete te.editing_type;
                          delete te.editing_asIsToBe
                          delete te.editing_weight;
                          delete te.weight;
                          delete te.is_exist;    
                          delete te.isEditing;
                          te.visible = true
                          te.title =te.title
                          if (te.type === "radiogroup" || te.type === "dropdown" || te.type === "rating"){
                            const tempType = te.type
                            te.type = "matrixdropdown";
                            te.titleLocation = "hidden";
                            te.columns = []
                            if (tempType !== "rating"){
                              te.columns = [
                                {
                                  name: te.name,
                                  title: te.title,
                                  cellType: tempType,
                                  choices: te.choices
                                },
                              ]
                            }else{
                               te.columns = [
                                {
                                  name: te.name,
                                  title: te.title,
                                  cellType: tempType,
                                  rateCount: te.rateCount,
                                  rateType: te.rateType,
                                  rateMax : subElement.rateMax,
                                  displayMode : subElement.buttons
                                },
                              ]
                            }
                           
                            te.rows = [
                              { text: "Current", value: "Current" },
                              { text: "Target", value: "Target" }
                            ]
                            te.transposeData = true;
                          }

                      });

                      subElement.value = [valueObj];
                      subElement.panelCount = 1  
                      subElement.readOnly= false
                      subElement.allowAddPanel= false
                      subElement.allowRemovePanel=false
                    }
               });
             }
           });
         }); 
       } else {
         _currentSurvey.pages.filter(x => x.name !== "intro" && x.type !== "demographics").forEach((page) => {
           page.elements[0].elements.forEach((element) => {
             if (element.type === "panel") {
               element.elements.forEach((subElement) => {
                if (subElement.asIsToBe && (subElement.type === "radiogroup" || subElement.type === "dropdown" || subElement.type === "rating")){
                  const tempType = subElement.type
                  subElement.type = "matrixdropdown";
                  subElement.titleLocation = "hidden";
                  subElement.columns = []
                  if (tempType !== "rating"){
                    subElement.columns = [
                     {
                       name: subElement.name,
                       title: subElement.title,
                       cellType: tempType,
                       choices: subElement.choices
                     },
                    ]
                  }else{
                     subElement.columns = [
                      {
                        name: subElement.name,
                        title: subElement.title,
                        cellType: tempType,
                        rateCount: subElement.rateCount,
                        rateType: subElement.rateType,
                        rateMax : subElement.rateMax,
                        displayMode : subElement.buttons
                      },
                    ]
                  }
                  subElement.rows = [
                    { text: "Current", value: "Current" },
                    { text: "Target", value: "Target" }
                  ]
                  subElement.transposeData = true;
                }
                else if (subElement.type === "matrixdropdown") {
                   subElement.type =  subElement.columns[0].cellType;
                   subElement.titleLocation = "top";
                   subElement.choices = subElement.columns[0].choices;
                   delete subElement.rows;
                   delete subElement.columns;
                   delete subElement.transposeData;
                 }
               });
             }else if (element.type === "paneldynamic") {
                const valueObj = {};
                element.templateElements.forEach((te) => {
                    
                    valueObj[te.name] = ""; // boş başlangıç değeri
                });

                element.value = [valueObj];
                element.panelCount = 1  
                element.readOnly= false
                element.allowAddPanel= false
                element.allowRemovePanel=false
                
               element.templateElements.forEach((subElement) => {
                  delete subElement.editing_type;
                  delete subElement.elements;
                  delete subElement.editing_elements;
                  delete subElement.editing_name;
                  delete subElement.editing_type;
                  delete subElement.editing_asIsToBe
                  delete subElement.editing_weight;
                  delete subElement.weight;
                  delete subElement.is_exist;    
                  delete subElement.isEditing;
                  subElement.visible = true
                  subElement.title =subElement.title
                  if (subElement.asIsToBe && (subElement.type === "radiogroup" || subElement.type === "dropdown" || subElement.type === "rating")){
                    const tempType = subElement.type
                    subElement.type = "matrixdropdown";
                    subElement.titleLocation = "hidden";
                    subElement.columns = []
                    if (tempType !== "rating"){
                      subElement.columns = [
                        {
                          name: subElement.name,
                          title: subElement.title,
                          cellType: tempType,
                          choices: subElement.choices
                        },
                      ]
                    }else{
                       subElement.columns = [
                        {
                          name: subElement.name,
                          title: subElement.title,
                          cellType: tempType,
                          rateCount: subElement.rateCount,
                          rateType: subElement.rateType,
                          rateMax : subElement.rateMax,
                          displayMode : subElement.buttons
                        },
                      ]
                    }
                   
                    subElement.rows = [
                      { text: "Current", value: "Current" },
                      { text: "Target", value: "Target" }
                    ]
                    subElement.transposeData = true;
                  }
                  else if (subElement.type === "matrixdropdown") {
                    subElement.type =  subElement.columns.cellType;
                    subElement.titleLocation = "top";
                    subElement.choices = subElement.columns[0].choices;
                    delete subElement.rows;
                    delete subElement.columns;
                    delete subElement.transposeData;
                    delete subElement.editing_type;
                    delete subElement.isEditing;
                    delete subElement.elements;
                    delete subElement.editing_elements;
                    delete subElement.editing_name;
                    delete subElement.editing_type;
                    delete subElement.editing_asIsToBe
                    delete subElement.editing_weight;
                    delete subElement.weight;
                    delete subElement.isExist;                   
                  }else if(subElement.type==="paneldynamic"){
                      const valueObj = {};
                      subElement.templateElements.forEach((te) => {
                          valueObj[te.name] = ""; // boş başlangıç değeri
                          delete te.editing_type;
                          delete te.elements;
                          delete te.editing_elements;
                          delete te.editing_name;
                          delete te.editing_type;
                          delete te.editing_asIsToBe
                          delete te.editing_weight;
                          delete te.weight;
                          delete te.is_exist;    
                          delete te.isEditing;
                          te.visible = true
                          te.title =te.title
                          if (te.asIsToBe && (te.type === "radiogroup" || te.type === "dropdown" || te.type === "rating")){
                            const tempType = te.type
                            te.type = "matrixdropdown";
                            te.titleLocation = "hidden";
                            te.columns = []
                            if (tempType !== "rating"){
                              te.columns = [
                                {
                                  name: te.name,
                                  title: te.title,
                                  cellType: tempType,
                                  choices: te.choices
                                },
                              ]
                            }else{
                               te.columns = [
                                {
                                  name: te.name,
                                  title: te.title,
                                  cellType: tempType,
                                  rateCount: te.rateCount,
                                  rateType: te.rateType,
                                  rateMax : subElement.rateMax,
                                  displayMode : subElement.buttons
                                },
                              ]
                            }
                           
                            te.rows = [
                              { text: "Current", value: "Current" },
                              { text: "Target", value: "Target" }
                            ]
                            te.transposeData = true;
                          }
                          else if (te.type === "matrixdropdown") {
                            te.type =  te.columns.cellType;
                            te.titleLocation = "top";
                            te.choices = te.columns[0].choices;
                            delete te.rows;
                            delete te.columns;
                            delete te.transposeData;
                            delete te.editing_type;
                            delete te.isEditing;
                            delete te.elements;
                            delete te.editing_elements;
                            delete te.editing_name;
                            delete te.editing_type;
                            delete te.editing_asIsToBe
                            delete te.editing_weight;
                            delete te.weight;
                            delete te.isExist;                   
                          }

                      });

                      subElement.value = [valueObj];
                      subElement.panelCount = 1  
                      subElement.readOnly= false
                      subElement.allowAddPanel= false
                      subElement.allowRemovePanel=false
                    }
               });
             }
           });
         });
       }
       return _currentSurvey;
  };
  let arrangedSurvey=arrangeSurvey(surveyCopy)
  const surveyModel = new Model(arrangedSurvey);
  const question = surveyModel.getQuestionByName("Question");
  if (question && question.panels.length === 0) {
      question.addPanel(); 
  }

  return <Survey model={surveyModel} />;
};

export default SurveyPreview;
